import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { RollOverRequestContainer } from "../containers";
import PersonalInvestmentPerformance from "../containers/Employee/EmployeeInformationContainer/PersonalInvestmentPerformance";
import {
  BeneficiaryDetails,
  EmployeeInformation,
  EmployeeManagePlans,
  EmployeeManagePlansModules,
  ManageCensusHistory,
  ManualEnrollment,
  AddBeneficiary,
  ManageCensusTransactions,
  EmployeeAccountBalance,
} from "../layouts";
import RollOverPlanDetails from "../layouts/Employee/RollOverPlanDetails";

import { ROUTES, MANAGE_CENSUS_ROUTES, ApplicationRoute } from "../utils";

const menu = "employees";
const flow = "edit";
export const ManageCensusRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_INFORMATION}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_INFORMATION}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={EmployeeInformation}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLANS}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLANS}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={EmployeeManagePlans}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLAN_MODULES}/:flow(add|edit|save)/:censusId?/:planId?`,
        ]}
        component={EmployeeManagePlansModules}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_HISTORY}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_HISTORY}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={ManageCensusHistory}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          //`${MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST}/:censusId?/:requestId?`,
          `${MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST}/:flow(add|edit|save)/:censusId?/:requestId?/:fromPage?`,
        ]}
        component={RollOverRequestContainer}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          //`${MANAGE_CENSUS_ROUTES.ROLLOVER_SUMMARY}/:censusId?/:summaryId?`,
          `${MANAGE_CENSUS_ROUTES.ROLLOVER_SUMMARY}/:flow(add|edit|save|approve)/:censusId?/:summaryId?/:fromPage?`,
        ]}
        component={RollOverPlanDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={ManageCensusTransactions}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={BeneficiaryDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.INVESTMENT_PERFORMANCE}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.INVESTMENT_PERFORMANCE}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={PersonalInvestmentPerformance}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY}/:flow(add|edit|save)/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY}/:flow(add|edit|save)/:censusId?/:beneficiaryId?`,
        ]}
        component={AddBeneficiary}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.MANUAL_ENROLLMENT}/:censusId?/:planId?`,
          `${MANAGE_CENSUS_ROUTES.MANUAL_ENROLLMENT}/:flow(add|edit|save)/:censusId?/:planId?`,
        ]}
        component={ManualEnrollment}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_CENSUS_ROUTES.ACCOUNT_BALANCE}/:censusId?`,
          `${MANAGE_CENSUS_ROUTES.ACCOUNT_BALANCE}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={EmployeeAccountBalance}
      />
      <Redirect
        exact
        menu={menu}
        from={ROUTES.MANAGE_EMPLOYEE}
        to={ROUTES.MANAGE_CENSUS}
      />
      <Redirect to={ROUTES.HOME} />
    </Switch>
  );
};
